import React, { useState, useEffect } from 'react'
import { Card, Space, Button, Input, Form, message, Tooltip, Tag, Divider, Spin, Row, Col, Empty } from 'antd';
import { getData, API, usuario, updateData, sendDataBody } from '../../resources';
import {
    FormOutlined,
    MedicineBoxOutlined,
    TeamOutlined,
    FileTextOutlined,
    UserOutlined,
    HeartOutlined,
    EnvironmentOutlined,
    BookOutlined,
    ManOutlined,
    WomanOutlined,
    IdcardOutlined,
    ReadOutlined,
} from '@ant-design/icons';


// PARENT: src\doctorViews\expedientes\expedientes.jsx

export default function DetalleHistoria({ historia, detalles_paciente }) {

    const isMedic = usuario && usuario.rol && usuario.rol === 'Medico';


    const { TextArea } = Input;
    const [historiaData, setHistoriaData] = useState("")
    const [notaLoading, setHistoriaLoading] = useState(true)
    const [editing, setEditing] = useState(false)

    useEffect(() => {
        detalles_paciente ?
            getHistoriaData()
            :
            finifhGet()
    }, [detalles_paciente])

    const finifhGet = () => { setHistoriaData([]); setHistoriaLoading(false); }

    const getHistoriaData = () => {
        getData(`historias/${detalles_paciente._id}`).then(rs => { console.log('Historia data: ', rs); setHistoriaData(rs); setHistoriaLoading(false) })
    }

    const updateHistoria = (values) => {
        setEditing(false)
        const historiaExists = historiaData && historiaData.length > 0 && historiaData[0].historial
        historiaExists ?
            updateData(`historias/update/${historiaData[0]._id}`, values).then(rs => {
                if (rs.ok) {
                    message.success(rs.message || rs.error);
                } else {
                    message.error(rs.message || rs.error);
                }
            }).finally(() => {
                getHistoriaData()
                setEditing(false)
            })
            :
            sendDataBody(`historias/add`, { ...values, paciente: detalles_paciente._id }).then(rs => {
                if (rs.ok) {
                    message.success(rs.message || rs.error);
                } else {
                    message.error(rs.message || rs.error);
                }
            }).finally(() => {
                getHistoriaData()
                setEditing(false)
            })


        console.log('New Historia', values);
    }

    const SectionTitle = ({ icon, title }) => (
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 12 }}>
            {icon}
            <span style={{ fontSize: 14, fontWeight: 600, color: '#1a1a2e' }}>{title}</span>
        </div>
    )

    const HistoriaDetails = () => {
        return editing ?
            <div style={{ padding: '8px 0' }}>
                <Form name='historiaForm' initialValues={historiaData[0]?.historial ? { historial: historiaData[0]?.historial } : {}}
                    onFinish={updateHistoria}
                    layout="vertical"
                >
                    <Form.Item name='historial' label={<span style={{ fontWeight: 500 }}>Contenido de la historia</span>}>
                        <TextArea
                            rows={5}
                            style={{ borderRadius: 8, fontSize: 13 }}
                            placeholder="Escribe la historia clínica del paciente..."
                        />
                    </Form.Item>
                    <Space>
                        <Form.Item style={{ marginBottom: 0 }}>
                            <Button type="primary" htmlType="submit" form='historiaForm' shape="round" size="small">Guardar</Button>
                        </Form.Item>
                        <Form.Item style={{ marginBottom: 0 }}>
                            <Button onClick={() => setEditing(false)} shape="round" size="small">Cancelar</Button>
                        </Form.Item>
                    </Space>
                </Form>
            </div>
            :
            (
                historiaData.length > 0 ?
                    <div style={{
                        position: 'relative',
                        background: '#f8f9fc',
                        borderRadius: 8,
                        padding: '12px 16px',
                        maxHeight: 120,
                        overflow: 'auto',
                        border: '1px solid #eef0f5',
                    }}>
                        <span style={{
                            whiteSpace: 'pre-line',
                            textAlign: 'left',
                            wordWrap: 'normal',
                            fontSize: 13,
                            color: '#3a3a4a',
                            lineHeight: 1.7,
                        }}>{historiaData[0].historial}</span>


                        <div style={{ position: 'absolute', top: 8, right: 8 }}>
                            <Tooltip title="Editar historia clínica">
                                <span style={{ display: 'inline-block', cursor: !historia ? 'not-allowed' : 'pointer' }}>
                                    <Button
                                        className='btnIconCentered'
                                        onClick={() => setEditing(true)}
                                        size='small'
                                        disabled={!isMedic}
                                        type="primary"
                                        shape="round"
                                        icon={<FormOutlined />}
                                        style={{ pointerEvents: !isMedic ? 'none' : 'auto' }}
                                        ghost
                                    >
                                        Editar
                                    </Button>
                                </span>
                            </Tooltip>
                        </div>

                    </div>
                    :
                    <div onClick={() => setEditing(true)} style={{ cursor: 'pointer' }}>
                        <Empty
                            image={Empty.PRESENTED_IMAGE_SIMPLE}
                            description={
                                <span style={{ color: '#7b8794', fontSize: 14 }}>No hay una historia asignada a este paciente</span>
                            }
                        />
                    </div>
            )

    }

    const DataCard = ({ icon, label, data }) => (
        <div style={{
            background: '#f8f9fc',
            borderRadius: 8,
            padding: '10px 14px',
            marginBottom: 8,
            border: '1px solid #eef0f5',
            transition: 'box-shadow 0.2s ease',
        }}
            onMouseEnter={e => e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.06)'}
            onMouseLeave={e => e.currentTarget.style.boxShadow = 'none'}
        >
            <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 2 }}>
                {icon && <span style={{ color: '#7b8794', fontSize: 12 }}>{icon}</span>}
                <span style={{ fontSize: 11, fontWeight: 600, color: '#7b8794', textTransform: 'uppercase', letterSpacing: 0.5 }}>{label}</span>
            </div>
            <span style={{ fontSize: 14, fontWeight: 500, color: '#2a2a3a' }}>{data || '—'}</span>
        </div>
    )


    return (
        <Card
            style={{
                width: '100%',
                marginTop: 16,
                borderRadius: 10,
                border: '1px solid #eef0f5',
                boxShadow: '0 1px 4px rgba(0,0,0,0.04)',
            }}
            bodyStyle={{ padding: '20px 24px' }}
        >


            {/* HISTORIA SECTION */}
            {
                usuario && usuario.rol && usuario.rol === 'Medico' &&

                <>
                    {/* Header */}
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 6 }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                            <FileTextOutlined style={{ fontSize: 20, color: '#3c75ef' }} />
                            <h5 style={{ margin: 0, fontSize: 16, fontWeight: 600, color: '#1a1a2e' }}>Historia Clínica</h5>
                        </div>
                    </div>

                    <Divider style={{ margin: '12px 0 16px' }} />

                    {/* Historia content */}
                    {
                        notaLoading ?
                            <div style={{ textAlign: 'center', padding: '30px 0' }}>
                                <Spin tip="Cargando historia..." />
                            </div>
                            :
                            HistoriaDetails()

                    }

                    <Divider style={{ margin: '16px 0 12px' }} />
                </>
            }

            {/* Datos Clínicos */}

            <SectionTitle
                icon={<MedicineBoxOutlined style={{ fontSize: 16, color: '#3c75ef' }} />}
                title="Datos Clínicos"
            />

            <Row gutter={[12, 0]}>
                <Col span={8}>
                    <div style={{
                        background: '#f8f9fc',
                        borderRadius: 8,
                        padding: '10px 14px',
                        border: '1px solid #eef0f5',
                        flex: 1,
                    }}>
                        <span style={{ fontSize: 11, fontWeight: 600, color: '#7b8794', textTransform: 'uppercase', letterSpacing: 0.5 }}>
                            <TeamOutlined style={{ marginRight: 4 }} /> Grupo étnico
                        </span>
                        <p style={{ margin: '4px 0 0', fontSize: 14, fontWeight: 500, color: '#2a2a3a' }}>
                            {detalles_paciente.grupo_etnico || '—'}
                        </p>
                    </div>
                </Col>
                <Col span={8}>
                    <div style={{
                        background: '#f8f9fc',
                        borderRadius: 8,
                        padding: '10px 14px',
                        border: '1px solid #eef0f5',
                        flex: 1,
                    }}>
                        <span style={{ fontSize: 11, fontWeight: 600, color: '#7b8794', textTransform: 'uppercase', letterSpacing: 0.5, display: 'block', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                            <HeartOutlined style={{ marginRight: 4 }} /> Enfermedades clínicas
                        </span>
                        <div style={{ marginTop: 6, display: 'flex', flexWrap: 'wrap', gap: 4, maxHeight: 120, overflowY: 'auto', paddingBottom: 8, paddingRight: 4 }}>
                            {
                                detalles_paciente.enfermedades_medicas && detalles_paciente.enfermedades_medicas.length > 0 ?
                                    detalles_paciente.enfermedades_medicas.map((enf, i) => (
                                        <Tag key={i} color="blue" style={{ borderRadius: 12, fontSize: 12, whiteSpace: 'normal', wordBreak: 'break-word' }}>{enf}</Tag>
                                    ))
                                    :
                                    <span style={{ fontSize: 13, color: '#aaa' }}>Sin enfermedades registradas</span>
                            }
                        </div>
                    </div>
                </Col>
                <Col span={8} >
                    <div style={{
                        background: '#f8f9fc',
                        borderRadius: 8,
                        padding: '10px 14px',
                        border: '1px solid #eef0f5',
                        flex: 1,
                    }}>
                        <span style={{ fontSize: 11, fontWeight: 600, color: '#7b8794', textTransform: 'uppercase', letterSpacing: 0.5 }}>
                            <BookOutlined style={{ marginRight: 4 }} /> Diagnóstico
                        </span>
                        <p style={{ margin: '4px 0 0', fontSize: 14, fontWeight: 500, color: '#2a2a3a' }}>
                            {detalles_paciente.diagnostico || '—'}
                        </p>
                    </div>
                </Col>
            </Row>

            {/* Interrogatorio */}
            <Divider style={{ margin: '16px 0 12px' }} />

            <SectionTitle
                icon={<IdcardOutlined style={{ fontSize: 16, color: '#3c75ef' }} />}
                title="Interrogatorio"
            />

            <Row gutter={[12, 0]}>
                <Col span={6}>
                    <DataCard icon={<UserOutlined />} label='Sexo' data={detalles_paciente.sexo} />
                    <DataCard icon={<UserOutlined />} label='Edad' data={detalles_paciente.edad} />
                    {
                        detalles_paciente && detalles_paciente.fecha_nacimiento &&
                        <DataCard icon={<IdcardOutlined />} label='Fecha de nacimiento' data={new Date(detalles_paciente.fecha_nacimiento).toLocaleDateString('es-MX')} />
                    }
                </Col>
                <Col span={6}>
                    <DataCard label='Peso (kg)' data={detalles_paciente.peso} />
                    <DataCard label='Talla (cm)' data={detalles_paciente.talla} />
                </Col>
                <Col span={6}>
                    <DataCard icon={<IdcardOutlined />} label='Ocupación' data={detalles_paciente.ocupacion} />
                    <DataCard icon={<HeartOutlined />} label='Edo. civil' data={detalles_paciente.estado_civil} />
                </Col>
                <Col span={6}>
                    <DataCard icon={<ReadOutlined />} label='Escolaridad' data={detalles_paciente.escolaridad} />
                    <DataCard icon={<EnvironmentOutlined />} label='Lugar de nacimiento' data={detalles_paciente.lugar_de_nacimiento} />
                </Col>
            </Row>
        </Card>
    )
}
